// The one line every WhatsApp-sending screen shows while WhatsApp is paused
// (Jason, 5 Oct 2026: "WhatsApp is paused until the new number is live",
// instead of a false success). Pair with useWhatsAppStatus(): render it when
// `paused` is true — which includes a status that could not be read.
//
// `detail` says what that means on THIS screen ("The grower will not get a
// confirmation for this load."). The first sentence is never reworded.

import { MessageCircleOff } from 'lucide-react'
import clsx from 'clsx'
import { WHATSAPP_PAUSED_TEXT } from '@/lib/whatsappStatus'

export function WhatsAppPausedNote({ detail, className }: { detail?: string; className?: string }) {
  return (
    <p role="status"
      className={clsx('rounded-lg border border-amber-700/60 bg-amber-950/40 px-3 py-2 text-xs text-amber-200 flex items-start gap-2', className)}>
      <MessageCircleOff size={14} className="shrink-0 mt-0.5" aria-hidden="true" />
      <span>
        <b className="font-semibold">{WHATSAPP_PAUSED_TEXT}.</b>
        {detail ? <> {detail}</> : null}
      </span>
    </p>
  )
}
